import type { Event as DeviceEvent } from '@eppendorf/vnls-notifications-utils';
import { useQuery } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import { REPORTING_SERVICE_BASE_PATH } from '$shared/utils/api-paths';

export const stabilityReportEventsQueryKey = 'stabilityReportEvents';

interface RawStabilityEvent {
  message: string;
  timestamp: string;
  tags: string[];
}

/**
 * Fetches events for a stability report. The backend reads from S3
 * and returns the JSON directly. We map to DeviceEvent shape for EventRow.
 */
const fetchEventsData = async (reportId: string): Promise<DeviceEvent[]> => {
  const rawEvents = await fetcher.get<RawStabilityEvent[]>(
    `${REPORTING_SERVICE_BASE_PATH}/${reportId}/events`,
  );

  return rawEvents.map((event, index) => ({
    sourceEventId: `evt-${index}`,
    tenantId: '',
    message: event.message,
    timestamp: event.timestamp,
    subject: { type: 'device', id: '' },
    tags: event.tags,
  }));
};

export const createGetStabilityReportEventsQuery = (reportId: string) => ({
  queryKey: [stabilityReportEventsQueryKey, reportId],
  queryFn: () => fetchEventsData(reportId),
  enabled: Boolean(reportId),
});

export const useGetStabilityReportEvents = (reportId: string) =>
  useQuery<DeviceEvent[]>({
    ...createGetStabilityReportEventsQuery(reportId),
  });
